import {
  HttpApiError,
  HttpApiMiddleware,
  HttpApiSecurity,
} from "@effect/platform";

/** Machine-to-machine auth: only a system JWT (audience `system`) passes, never a merchant JWT. */
export class SystemAuthorization extends HttpApiMiddleware.Tag<SystemAuthorization>()(
  "SystemAuthorization",
  {
    failure: HttpApiError.Unauthorized,
    security: { bearer: HttpApiSecurity.bearer },
  },
) {}
